import React, { useState } from "react";
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { ls } from "../../../../variables";
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import { encrypt } from '../../../../utils/cipher';
import Styles from "../Styles/main.module.css";
import { errorHandler } from "../../../../utils/errorHandling";
import { useStateValue } from "../../../../Hooks/stateProvider";


export default function AlertDownloadDropDown({ fileLocations }) {

    const [anchorEl, setAnchorEl] = useState(null);
    const [{ moduleType, fy_year, quarter, pmsName }] = useStateValue();
    // const [open, setOpen] = useState(false);
    const open = Boolean(anchorEl)
    const navigate = useNavigate();
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
        // setOpen(true);
    };
    const handleClose = () => {
        setAnchorEl(null);
        // setOpen(false);
    };

    const downloadFile = async (location) => {
        console.log("s3 location alert",location)
        const payload = {
            s3Location: location,
            moduleType: moduleType.toUpperCase(),
            authToken: ls.get("authToken"),
            refreshToken: ls.get("refreshToken"),
        };
        const encryptedPayload = await encrypt(payload);
        axios
            .post(
                "/api/pms/downloadReport",
                { payload: encryptedPayload }
            )
            .then((val) => {
                window.open(val?.data?.data, "_self");
            })
            .catch((err) => {
                errorHandler(err, navigate)
            });
    }
    const handleDownload = async () => {
        const payload = {
          fy_year: fy_year,
          quarter: quarter,
          moduleType:moduleType,
          pmsName: pmsName,
          authToken: ls.get("authToken"),
          refreshToken: ls.get("refreshToken")
        }
    
        const encryptedPayload = await encrypt(payload)
        
        axios
          .post("/api/pms/downloadFile", {
            payload: encryptedPayload
          })
          .then((res) => {
            window.open(res.data.data, "_self");
          })
          .catch((err) => {
            errorHandler(err, navigate);
          })
      };
    
    const downloadAlertGreenNote = async ()=>{
        const payload = {
            fy_year: fy_year,
            quarter: quarter,
            pmsName: pmsName,
            downloadType: "greenNote",
            moduleType: moduleType.toUpperCase(),
            authToken: ls.get("authToken"),
            refreshToken: ls.get("refreshToken"),
        }
        const encryptedPayload = await encrypt(payload)
        axios.post("/api/pms/downloadReport", {payload: encryptedPayload})
            .then((res)=>{
                window.open(res.data.data, "_self")
            }).catch((error)=>{
                console.log(error.message)
            })
    }

    return (
        <div >
            <Button
                className={Styles.DownloadCTRHYTR}
                id="demo-customized-button"
                aria-controls={open ? 'demo-customized-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                variant="contained"
                onClick={handleClick}
            >
                Download
                <KeyboardArrowDownIcon />
            </Button>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}
            >
                <MenuItem
                    onClick={() => {
                        handleDownload();
                    }}
                >
                    Download Alerts
                </MenuItem>
                <MenuItem disabled={fileLocations.s3_location ==="undefined" ? true : false} onClick={() => { downloadFile(fileLocations?.s3_location) }}>Download Exceptional Files</MenuItem>
                {/* <MenuItem
                    onClick={() => {
                        downloadAlertGreenNote();
                    }}
                >
                    Download View History
                </MenuItem> */}
            </Menu>
        </div >
    );
}
